import { SortEnum } from "./types";

export const DEFAULT_SORT_OPTION = SortEnum.DISTANCE;
